<template>
  <div>
    <v-alert
      v-if="showWarning"
      type="warning"
      variant="tonal"
      density="compact"
      closable
      class="ma-3 mb-0"
      @click:close="auth.passwordWarningDismissed = true"
    >
      <div class="d-flex align-center flex-wrap" style="gap:8px;">
        <span>Jou wagwoord verval oor {{ auth.passwordDaysLeft }} {{ auth.passwordDaysLeft === 1 ? 'dag' : 'dae' }}. Verander dit nou.</span>
        <v-btn size="small" variant="outlined" @click="auth.passwordDialogOpen = true">Verander wagwoord</v-btn>
      </div>
    </v-alert>

    <v-dialog v-model="auth.passwordDialogOpen" max-width="440" fullscreen-breakpoint="xs" @update:model-value="onToggle">
      <v-card class="pa-6" style="border-radius:12px;">
        <v-card-title class="mb-2">Verander wagwoord</v-card-title>
        <v-form v-model="valid" @submit.prevent="submit">
          <PasswordField v-model="current" label="Huidige wagwoord" autocomplete="current-password" :judge="false"></PasswordField>
          <PasswordField v-model="next" label="Nuwe wagwoord" :email="auth.email || ''" :first-name="auth.firstName || ''"></PasswordField>
          <PasswordField v-model="confirm" :must-match="next"></PasswordField>
          <v-alert v-if="errorMessage" type="error" variant="tonal" density="compact" class="mb-4">{{ errorMessage }}</v-alert>
          <v-alert v-if="done" type="success" variant="tonal" density="compact" class="mb-4">Wagwoord verander.</v-alert>
          <v-card-actions class="px-0">
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="auth.passwordDialogOpen = false">{{ done ? 'Toemaak' : 'Kanselleer' }}</v-btn>
            <v-btn
              type="submit"
              style="background-color:var(--c-brand);color:#ffffff;"
              size="large"
              :disabled="!valid || done"
              :loading="saving"
            >
              Stoor
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { request } from '@/utils/api';
import { useAuthStore } from '@/stores/auth';
import { serverMessage } from '@/utils/passwordRules';
import PasswordField from '@/components/PasswordField.vue';

// The signed-in user's "Verander wagwoord" dialog, plus the slim warning shown in the last
// 14 days before the password expires.
export default {
  name: 'PasswordChangeDialog',
  components: { PasswordField },
  setup() {
    const auth = useAuthStore();
    const valid = ref(false);
    const saving = ref(false);
    const done = ref(false);
    const errorMessage = ref('');
    const current = ref('');
    const next = ref('');
    const confirm = ref('');

    const showWarning = computed(() => auth.passwordDaysLeft !== null && !auth.passwordWarningDismissed && !!auth.token);

    const reset = () => {
      current.value = '';
      next.value = '';
      confirm.value = '';
      errorMessage.value = '';
      done.value = false;
    };
    const onToggle = (open) => {
      if (open) {
        reset();
      }
    };

    const submit = async () => {
      if (!valid.value) {
        return;
      }
      saving.value = true;
      errorMessage.value = '';
      try {
        await request('PUT', '/users/me/password', { currentPassword: current.value, newPassword: next.value });
        done.value = true;
        auth.setPasswordDaysLeft(null);
        current.value = '';
        next.value = '';
        confirm.value = '';
      } catch (error) {
        errorMessage.value = serverMessage(error, 'Kon nie die wagwoord verander nie. Kontroleer jou huidige wagwoord.');
      } finally {
        saving.value = false;
      }
    };

    return { auth, valid, saving, done, errorMessage, current, next, confirm, showWarning, onToggle, submit };
  },
};
</script>
